import Bean from 'bean';
import deepFreeze from '../utilities/freeze';
import CommonInterface from './commonInterface';
export default class BaseComponent extends CommonInterface {
    /**
     *
     * constructor
     *
     * @param {Element} element
     */
    constructor(element) {
        super();
        this._componentElement = element;
        this._componentElement.setAttribute('data-component-init', 'true');
        this._checkMessages();
    }
    /**
     * @returns {HTMLElement}
     */
    get $el() {
        return this._componentElement;
    }
    get $options() {
        const compOptions = {};
        const options = Object.assign({}, this.$el.dataset);
        const optionsEntires = Object.keys(options).filter((entry) => entry.includes('option'));
        optionsEntires.forEach((entry) => {
            const cleanEntry = BaseComponent.cleanOptionKey(entry);
            let optionValue;
            if (options[entry].includes('{') && options[entry].includes('}')) {
                optionValue = JSON.parse(options[entry].replace(/'/g, '"'));
            }
            else {
                optionValue = BaseComponent.convertType(options[entry]);
            }
            compOptions[cleanEntry] = optionValue;
        });
        return deepFreeze(compOptions);
    }
    get COMPONENT_NAME() {
        return this.__proto__.constructor.name;
    }
    static convertType(option) {
        let optionReturn;
        switch (option) {
            case 'false':
                optionReturn = false;
                break;
            case 'true':
                optionReturn = true;
                break;
            case 'null':
                optionReturn = null;
                break;
            default:
                optionReturn = option;
                break;
        }
        return optionReturn;
    }
    static cleanOptionKey(key) {
        const str = key.replace('option', '');
        return `${str.charAt(0).toLocaleLowerCase()}${str.slice(1)}`;
    }
    /**
     *
     * $on
     *
     * @param {String} events
     * @param {Function} cb
     * @param {Element} [element = this.$el]
     * @param {Array|String|Element} [elements = null]
     */
    $on(events, cb, element = this.$el, elements = null) {
        if (!element || !events || !cb)
            return;
        if (!elements) {
            Bean.on(element, events, (e) => {
                if (e)
                    e.stopPropagation();
                cb(e);
            });
        }
        else {
            Bean.on(element, events, elements, (e) => {
                if (e)
                    e.stopPropagation();
                cb(e);
            });
        }
    }
    /**
     *
     * $one
     *
     * @param {String} events
     * @param {Function} cb
     * @param {Element} [element = this.$el]
     */
    $one(events, cb, element = this.$el) {
        Bean.one(element, events, cb);
    }
    /**
     *
     * $off
     *
     * @param {String} events
     * @param {Element} [element = this.$el]
     */
    $off(events, element = this.$el) {
        Bean.off(element, events);
    }
    /**
     *
     * $fire
     *
     * @param {String} events
     * @param {Element} [element = this.$el]
     */
    $fire(events, element = this.$el) {
        Bean.fire(element, events);
    }
}
